import styled from "styled-components";

import { ReactComponent as ArrowLeftSVG } from "../assets/svg/arrow-left-icon.svg";
import { ReactComponent as EyeSVG } from "../assets/svg/eye-icon.svg";

import { ContainerFlexLeft } from "./AppStyles";

export const LoginContainer = styled(ContainerFlexLeft)`
  padding-top: 8vh;

  > span {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      margin: 0;
    }
  }
`;

export const LoginCredentialsContainer = styled(ContainerFlexLeft)`
  padding-top: 8vh;
  padding-bottom: 12vh;

  > span {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      margin: 0;
    }
  }

  u {
    color: ${(props) => props.theme.secondColor};
    font-weight: bold;

    &:hover {
      cursor: pointer;
    }
  }
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 45%;

  && h2 {
    font-weight: bold;
    color: ${(props) => props.theme.firstColor};
  }
  
  > span {
    > span {
      position: relative;
      width: 100%;
    }
  }

  div {
    u {
      color: ${(props) => props.theme.secondColor};
      font-weight: bold;

      &:hover {
        cursor: pointer;
      }
    }
  }

  && > div:nth-of-type(1) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 2rem;

    span {
      display: flex;
      align-items: center;
      height: 100%;
      
      input[type="checkbox"] {
        margin: 0 0.5rem 0 0;
        background: ${(props) => props.theme.tenthColor};
        border: 1px solid #969696;
        box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.1);
        border-radius: 0;
        height: 1.5rem;
        width: 1.5rem;
      } 
      label {
        font-size: 0.8rem;
        color: ${(props) => props.theme.firstColor};
      }
    }
  }
`;

//Icons
export const ArrowLeftIcon = styled(ArrowLeftSVG)`
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 5px;
`;
export const EyeIcon = styled(EyeSVG)`
  color: ${(props) => props.theme.ninthColor};
  position: absolute;
  top: 50%;
  right: 5px;
  height: 40%;
  aspect-ratio: 1 / 1;
  transform: translate(0, -50%);
`;
